import { RESET_ACTION_TYPE } from './constants';

export default (mapper) => (wrappedReducer) => (previousState, action = {}) =>
  wrappedReducer(previousState, action.type === RESET_ACTION_TYPE ? action : mapper(action));
